import React from 'react';
import styled from 'styled-components';

import Image from './Image';

import { MediaFragment } from '../schemas/api';

import COLORS from '../styles/colors';
import TYPO from '../styles/typography';
import useTypeformScript from '../hooks/useTypeformScript';

const Container = styled.div`
  width: 100%;
  display: flex;

  position: relative;

  border: 1px solid ${COLORS.brand.regular.css};
  border-radius: 6px;
  overflow: hidden;
  max-height: 360px;
  margin-top: 24px;

  & > img {
    display: none;
  }

  @media (min-width: 768px) {
    & > img {
      display: block;
    }
  }
`;

const Content = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  width: 100%;
  gap: 12px;
  @media (min-width: 768px) {
    width: 50%;
    padding: 42px;
    padding-right: 0;
  }
`;

const Heading = styled.h2`
  ${TYPO.h2};
  font-size: 32px;
  line-height: 110%;
  font-weight: 600;
`;

const Description = styled.p`
  ${TYPO.p2}
  margin: 0;
  margin-bottom: 12px;
`;

type HandbookPostFirewallProps = {
  heading: string;
  description: string;
  typeformFormId: string;
  image: MediaFragment;
};

export default function HandbookPostFirewall({
  heading,
  description,
  typeformFormId,
  image,
}: HandbookPostFirewallProps) {
  useTypeformScript();
  return (
    <Container>
      <Content>
        <Heading>{heading}</Heading>
        <Description>{description}</Description>
        {typeformFormId && <div data-tf-live={typeformFormId}></div>}
      </Content>
      <Image
        src={image.url}
        width={image.width}
        height={image.height}
        alt={image.title}
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          objectFit: 'cover',
          height: '100%',
          width: '50%',
          flex: 1,
        }}
      />
    </Container>
  );
}
